import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const reportData = createAsyncThunk(
  "report/fetch",
  async ({ data, api }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/${api}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState: {
    data: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {
    clearReportData: (state) => {
      state.data = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(reportData.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(reportData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(reportData.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});
export const { clearReportData } = reportSlice.actions;
export default reportSlice.reducer;
